// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles-module--heading--Eqr2P","fadeIn":"styles-module--fadeIn--39CVw","pulse":"styles-module--pulse--92asV","slideInDown":"styles-module--slideInDown--258vm"};